module.exports = __webpack_public_path__ + "img/thumb_down.8e5a4151.svg";